export default __webpack_public_path__ + "static/media/seleccionados_cdmx2026.5c0958a4.pdf";